<template>
    <div
        :data-item-id="product.ItemID"
        class="v2-retailer-order__brand-product"
    >
        <div class="v2-retailer-order__brand-product-logo">
            <img
                :src="product.images.length ? product.images[0].url : null"
                alt=""
                class="v2-retailer-order__brand-product-img ofi"
            />
        </div>
        <div class="v2-retailer-order__brand-product-descr">
            <div class="v2-retailer-order__brand-product-descr-left">
                <div class="v2-retailer-order__brand-product-brand">
                    {{ product.brand.BrandName }}
                </div>
                <div class="v2-retailer-order__brand-product-text">
                    {{ product.type.Name }}
                </div>
                <div
                    class="v2-retailer-order__brand-product-text v2-retailer-order__brand-product-text--gray mb-2"
                >
                    Арт. {{ product.Article }}
                </div>
                <div class="v2-retailer-order__brand-product-text">
                    {{ getFormattedNum(product.pivot.Price || 0) }} Р/{{
                        getNameById(
                            priceUnitOptions,
                            'abbr',
                            'id',
                            product.PriceUnit
                        )
                    }}
                </div>
                <div class="v2-retailer-order__brand-product-comment">
                    Комментарий
                    <span>{{ product.pivot.Comment || ' — ' }}</span>
                </div>
            </div>

            <div class="v2-retailer-order__brand-product-descr-right">
                <div class="v2-retailer-order__brand-product-summary">
                    {{ getFormattedNum(totalPrice.toFixed(2) || 0) }} Р
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import getNameById from '@/mixins/getNameById'
import getFormattedNum from '@/utils/getFormattedNum'

export default {
    name: 'OrderProductItem',
    mixins: [getNameById],
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState('other', ['priceUnitOptions']),
        totalPrice() {
            let totalPrice =
                parseFloat(this.product.pivot.Price || 0) *
                parseInt(this.product.pivot.Quantity)

            //если цена за грамм
            if (parseInt(this.product.PriceUnit) == 2) {
                totalPrice = totalPrice * parseInt(this.product.Weight)
            }

            return totalPrice
        }
    },
    methods: {
        getFormattedNum
    }
}
</script>
